
import { defineComponent } from "vue";
import runEvn from "../../../modular/runEvn/RunEvn";
const fileBaseUrl = runEvn().fileBaseUrl;
import { useRouter } from "vue-router";
import { getCloudClassRoom } from "@/api/CloudClassRoomAPI";
import cloudClassItem from '@/views/mulin/components/cloudClassItem.vue'

export default defineComponent({
    setup() {
        const router = useRouter();

        return {
            router,
        };
    },
    components: { cloudClassItem },
    // mounted() {
    //     this.loadData();
    // },
    data() {
        return {
            formData: [],
            searchVal: "",
            option1: [
                { text: "站点", value: "" },
                { text: "文冲", value: 1 },
                { text: "新造", value: 2 },
                { text: "长洲", value: 3 },
                { text: "其它", value: 4 },
            ],
            option2: [
                { text: "排序", value: "" },
                { text: "发布时间", value: "CreateTimeStamp" },
                { text: "观看人数", value: "VisitsCount" },
            ],
            option3: [
                { text: "类别", value: "" },
                { text: "本地文化", value: "本地文化" },
                { text: "科普教育", value: "科普教育" },
                { text: "才艺展示", value: "才艺展示" },
                { text: "休闲娱乐", value: "休闲娱乐" },
                { text: "疫情防控", value: "疫情防控" },
            ],
            searchParams: {
                MainCategory: "", // 类别
                SortName: "", // 排序
                SiteId: "", // 站点
                Title: "",
            },
        };
    },
    methods: {
        async loadData() {
            let params = {
                MainCategory: "",
                SubCategory: "",
                SiteId: "",
            };
            let Promise: any = await getCloudClassRoom(params);
            if (Promise) {
                console.log(Promise);

                this.formData = Promise.rows;
            }
        },
        async loadOrganizeActivitiy({ index, setData }) {
            const params = {
                ...this.searchParams,
            };
            const response = (await getCloudClassRoom(params)) || {
                rows: [],
            };
            setData(response.rows, response.total);
        },
        refreshData() {
            this.$refs.appListRef.onRefresh();
        },
    },
});
